/* @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography, breakpoints } from '@coursera/cds-core';

import TrackedDiv from 'bundles/page/components/TrackedDiv';

const styles = {
  testimonialQuote: css`
    background-color: var(--cds-color-neutral-background-primary);
    height: 375px;
    padding: 55px 75px;
    border-radius: 6px;
    box-shadow: var(--cds-color-grey-200) 0 3px 30px;
    ${breakpoints.down('sm')} {
      padding: 25px 35px;
      box-shadow: var(--cds-color-grey-200) 0 3px 15px;
    }
    ${breakpoints.down('xs')} {
      height: initial;
    }
  `,
  quote: css`
    ${breakpoints.up('xs')} {
      height: 60%;
    }
  `,
};

type Props = {
  index: number;
  text?: string | null;
  author?: React.ReactNode;
};

const TestimonialQuoteModule = ({ index, text, author }: Props) => {
  if (!text) {
    return null;
  }

  return (
    <TrackedDiv
      key={`testimonial-quote-${index}`}
      trackingName="testimonial"
      data={{ indexPosition: index + 1 }}
      withVisibilityTracking
      css={styles.testimonialQuote}
    >
      <Typography css={styles.quote} variant="h2" component="p" align="center">
        {text}
      </Typography>
      {author}
    </TrackedDiv>
  );
};

export default TestimonialQuoteModule;
